import withAemIntegration from "../../../../withAemIntegration";

const EditConfig = {
  emptyLabel: "Brochure Year Mapping Data",
  isEmpty: function (props) {
    return !props || !props.year || props.year.trim().length < 1;
  },
};

const Render = (props) => {
  return <div>{props.year} Brochure Mapping Data</div>;
};

export default withAemIntegration(
  "lexus/components/inventory/data-dialogs/brochure-year-mapping"
)(Render, EditConfig);
